import http from '@axios'

export default {
  methods: {
    $_downloadBlobUrl(blob, filename) {
      // Create an object URL for the blob object
      const url = URL.createObjectURL(blob)

      // Create a new anchor element
      const a = document.createElement('a')

      // Set the href and download attributes for the anchor element
      // You can optionally set other attributes like `title`, etc
      // Especially, if the anchor element will be attached to the DOM
      a.href = url
      a.download = filename || 'download'

      // Click handler that releases the object URL after the element has been clicked
      // This is required for one-off downloads of the blob content
      const clickHandler = () => {
        setTimeout(() => {
          URL.revokeObjectURL(url)
          this.removeEventListener('click', clickHandler)
        }, 150)
      }

      // Add the click event listener on the anchor element
      // Comment out this line if you don't want a one-off download of the blob content
      a.addEventListener('click', clickHandler, false)

      // Programmatically trigger a click on the anchor element
      // Useful if you want the download to happen automatically
      // Without attaching the anchor element to the DOM
      // Comment out this line if you don't want an automatic download of the blob content
      a.click()

      // Return the anchor element
      // Useful if you want a reference to the element
      // in order to attach it to the DOM or use it in some other way
      return a
    },

    $_downloadBlob(url) {
      console.log(url)
      const url_parts = url.split('/')
      // fetch(`https://api.allorigins.win/raw?url=${url}`, {
      fetch(url, {
        // headers: {
        //   'Content-Type': 'application/octet-stream',
        //   'Content-Transfer-Encoding': 'binary',
        //   'Cache-Control': 'must-revalidate',
        // },
        // mode: 'no-cors',
        // responseType: 'blob',
      }).then(t => t.blob().then(b => {
        const a = document.createElement('a')
        console.log(b)
        a.href = URL.createObjectURL(b)
        a.setAttribute('download', url_parts.reverse()[0])
        a.click()
      }))
    },

    $_downloadFromUrl(url) {
      const url_parts = url.split('/')
      const filename = url_parts[url_parts.length - 1]
      const wrapp = document.createElement('div')
      wrapp.innerHTML = `
      <a
        id="link_download"
        href="${url}"
        download="${filename}">
      </a>
      `
      document.body.appendChild(wrapp)
      this.$nextTick(() => {
        const link_download = document.getElementById('link_download')
        link_download.click()
        wrapp.remove()
      })
    },

    $_getFile(url) {
      http({
        method: 'GET',
        url,
        responseType: 'blob',
        headers: {
          // 'Access-Control-Allow-Origin': '*',
          // 'Content-Type': 'application/json',
          'Content-Type': 'application/pdf',
          'Cache-Control': 'no-cache',
        },
      })
    },
    $_downloadMultipleFiles(urls) {
      urls.forEach(url => {
        const iframe = document.createElement('iframe')
        iframe.style.visibility = 'collapse'
        document.body.append(iframe)

        iframe.contentDocument.write(
          `<form action="${url.replace(/"/g, '"')}" method="GET"></form>`,
        )
        iframe.contentDocument.forms[0].submit()

        setTimeout(() => iframe.remove(), 10000)
      })
    },
    $_downloadInterval(urls) {
      // eslint-disable-next-line no-use-before-define
      const interval = urls.length ? setInterval(download, 300, urls) : this.$_errorToast(this.$t('generals.error'))
      function download() {
        const url = urls.pop()

        const a = document.createElement('a')
        a.setAttribute('href', url)
        a.setAttribute('download', '')
        a.setAttribute('target', '_blank')
        a.click()

        if (urls.length === 0) {
          clearInterval(interval)
        }
      }
    },
  },
}
